module.exports = __webpack_public_path__ + "media/images/swines/14 week old pig fetus.jpg";